import gql from "graphql-tag";

export const createCatalogCategoryMutation = gql`
  mutation createCatalogCategory(
    $name: String!
    $isActive: Boolean
    $sort: Int
    $parentId: ID
    $forNotice: Boolean
    $productCategoryIds: [ID!]
  ) {
    createCatalogCategory(
      name: $name
      isActive: $isActive
      sort: $sort
      parentId: $parentId
      forNotice: $forNotice
      productCategoryIds: $productCategoryIds
    ) {
      id
    }
  }
`;
